import { BaseTypeSchema } from "../BaseTypeSchema";
import { VariableType } from "../VariableType";

export class IPV4Schema extends BaseTypeSchema
{
    static REGEX: RegExp = /^(25[0-5]|2[0-4][0-9]|[0-1]?[0-9][0-9]?)\.((25[0-5]|2[0-4][0-9]|[0-1]?[0-9][0-9]?)\.){2}(25[0-5]|2[0-4][0-9]|[0-1]?[0-9][0-9]?)$/;
    constructor(required: boolean)
    {
        super(VariableType.IPV4, required);
    }
}